import { FunctionComponent } from "react";

import { Spinner } from "./Spinner";

/** Brand blue — `Spinner` defaults to white, which is invisible on our light surfaces. */
const BRAND_LIGHT = "#4D66F5";

interface LoadingBlockProps {
	/** Vertical padding class; the default suits a panel or a modal body. */
	className?: string;
}

/**
 * The standard "this section is still loading" placeholder: a centered brand spinner.
 *
 * Exists so a loading state is never written as a text label — several CRM settings panels
 * rendered a `t("basics.loading")` string for a key that does not exist, so the raw key was
 * what the customer saw.
 */
export const LoadingBlock: FunctionComponent<LoadingBlockProps> = ({ className = "py-12" }) => (
	<div className={`flex justify-center ${className}`} data-testid="loading-block">
		<Spinner color={BRAND_LIGHT} />
	</div>
);
